import { Group, Stack, Text, ActionIcon } from '@mantine/core';
import { Link, useRouter } from '@tanstack/react-router';
import { IconArrowRight } from '@tabler/icons-react';
import { useAtom } from 'jotai';

import { accountsAtom } from '@data-access';

import styles from './account-info-header.module.css';

interface Account {
  id: number;
  last_name: string;
  first_name: string;
}

interface AccountInfoHeaderProps {
  farmName: string;
  account: Account;
}

export function AccountInfoHeader({
  farmName,
  account,
}: AccountInfoHeaderProps) {
  const router = useRouter();
  const [, setAccounts] = useAtom(accountsAtom);

  const handleNavigateToFields = () => {
    setAccounts([account.id]);
    router.navigate({
      to: '/fields',
    });
  };

  return (
    <Group preventGrowOverflow justify="space-between">
      <Link
        params={{ accountId: account.id.toString() }}
        to="/accounts/$accountId/edit"
        className={styles.link}
        style={{ flex: 1, minWidth: 0 }}
      >
        <Stack
          flex="1"
          gap={3}
          justify="center"
          style={{
            flexWrap: 'nowrap',
            minWidth: 0,
          }}
        >
          <Text fw={600} lh={1} size="sm" truncate="end">
            {farmName}
          </Text>
          <Text lh={1} size="sm" truncate="end" c="dimmed">
            {account.last_name} {account.first_name}
          </Text>
        </Stack>
      </Link>
      <ActionIcon
        variant="light"
        onClick={handleNavigateToFields}
        aria-label="Navigate to fields"
        style={{ flexShrink: 0 }}
        size="lg"
      >
        <IconArrowRight size={18} />
      </ActionIcon>
    </Group>
  );
}

export default AccountInfoHeader;

